import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap4-modal';
import { I18n } from '../../../../helpers/i18n';
import { updateMvpUserType, getBuddyYouthCommunity, fetchUserMvp } from 'redux/actions/user.action';
import '../../../mvpAuth/signin.scss';

const SENIOR = 'explorer';
const BUDDY = 'guide';
const BOTH = 'both';

class RoleSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: props.user?.mvpUserType || '',
      listBuddyYouthCommunity: [],
      youthCommunity: '',
      isLoading: false,
      showGuideModal: false,
      modalYouthCommunity: '',
    };
    this.youthCommunitySelectRef = React.createRef();
  }

  async componentDidMount() {
    const { getBuddyYouthCommunity, user } = this.props;
    this.setState({ selectedType: user?.mvpUserType || '' });
    
    // Fetch youth communities with forSignup to get Individual user, None of the above + DB communities (no N/A)
    const communities = await getBuddyYouthCommunity({ forSignup: true });
    if (communities) {
      // Always try to load youthCommunity from user props (even if user is currently explorer)
      // This allows pre-loading when user switches back to Guide
      let selectedYouthCommunity = '';
      if (user?.youthCommunity) {
        // Extract the actual ID/value from user.youthCommunity
        // It could be: string (_id), string (value), or object {value, label, _id}
        let youthCommunityToFind = null;
        if (typeof user.youthCommunity === 'string') {
          youthCommunityToFind = user.youthCommunity;
        } else if (user.youthCommunity && typeof user.youthCommunity === 'object') {
          // It's an object, try _id first, then value
          youthCommunityToFind = user.youthCommunity._id || user.youthCommunity.value;
        }
        
        if (youthCommunityToFind) {
          // Try to find by _id first (new format)
          const foundById = communities.find(c => c._id === youthCommunityToFind);
          if (foundById) {
            selectedYouthCommunity = foundById._id;
          } else {
            // Fallback: try to find by value (old format for backward compatibility)
            const foundByValue = communities.find(c => c.value === youthCommunityToFind);
            if (foundByValue) {
              selectedYouthCommunity = foundByValue._id;
            }
          }
        }
      }
      
      this.setState({ 
        listBuddyYouthCommunity: communities,
        youthCommunity: selectedYouthCommunity
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    const { listBuddyYouthCommunity, showGuideModal } = this.state;
    
    // Update selectedType when mvpUserType changes
    if (prevProps.user?.mvpUserType !== user?.mvpUserType) {
      this.setState({ selectedType: user?.mvpUserType || '' });
    }
    
    // Update youthCommunity whenever user props change (especially after fetchUserMvp)
    // Also update modalYouthCommunity if modal is currently showing
    if (user?.youthCommunity && listBuddyYouthCommunity.length > 0) {
      // Extract the actual ID/value from user.youthCommunity
      // It could be: string (_id), string (value), or object {value, label, _id}
      let youthCommunityToFind = null;
      if (typeof user.youthCommunity === 'string') {
        youthCommunityToFind = user.youthCommunity;
      } else if (user.youthCommunity && typeof user.youthCommunity === 'object') {
        // It's an object, try _id first, then value
        youthCommunityToFind = user.youthCommunity._id || user.youthCommunity.value;
      }
      
      if (youthCommunityToFind) {
        // Try to find by _id first
        const foundById = listBuddyYouthCommunity.find(c => c._id === youthCommunityToFind);
        if (foundById) {
          const updates = {};
          // Only update youthCommunity if different
          if (this.state.youthCommunity !== foundById._id) {
            updates.youthCommunity = foundById._id;
          }
          // Update modalYouthCommunity if modal is showing and value is different
          if (showGuideModal && this.state.modalYouthCommunity !== foundById._id) {
            updates.modalYouthCommunity = foundById._id;
          }
          if (Object.keys(updates).length > 0) {
            this.setState(updates);
          }
        } else {
          // Fallback: try to find by value
          const foundByValue = listBuddyYouthCommunity.find(c => c.value === youthCommunityToFind);
          if (foundByValue) {
            const updates = {};
            // Only update youthCommunity if different
            if (this.state.youthCommunity !== foundByValue._id) {
              updates.youthCommunity = foundByValue._id;
            }
            // Update modalYouthCommunity if modal is showing and value is different
            if (showGuideModal && this.state.modalYouthCommunity !== foundByValue._id) {
              updates.modalYouthCommunity = foundByValue._id;
            }
            if (Object.keys(updates).length > 0) {
              this.setState(updates);
            }
          }
        }
      }
    }
  }

  handleChooseType = async (value) => {
    if (this.state.isLoading) return;
    
    const currentType = this.state.selectedType;
    const userOriginalType = this.props.user?.mvpUserType || '';
    let newType = '';
    
    if (value === SENIOR) {
      // If clicking Explorer
      if (currentType === SENIOR) {
        // Trying to deselect Explorer
        // Only allow if user originally had 'both' (can switch to guide only)
        if (userOriginalType === BOTH) {
          // User has both, can remove explorer (keep guide)
          newType = BUDDY;
        } else {
          // User originally had explorer only, can't deselect without having guide first
          toast.warning(I18n.t('must_keep_at_least_one_role', {
            role: I18n.t('account_type_selection_senior_buddy'),
            currentRole: I18n.t('account_type_selection_senior')
          }) || 'Bạn phải giữ ít nhất một vai trò. Vui lòng chọn Guide trước khi tắt Explorer.', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-warning-container toast-warning-container-after',
          });
          return;
        }
      } else if (currentType === BUDDY) {
        // If Guide is selected, add Explorer (both)
        newType = BOTH;
      } else if (currentType === BOTH) {
        // If both selected, remove Explorer (keep Guide)
        newType = BUDDY;
      } else {
        // If nothing selected, select Explorer
        newType = SENIOR;
      }
    } else if (value === BUDDY) {
      // If clicking Guide
      if (currentType === BUDDY) {
        // Trying to deselect Guide
        // Only allow if user originally had 'both' (can switch to explorer only)
        if (userOriginalType === BOTH) {
          // User has both, can remove guide (keep explorer)
          newType = SENIOR;
        } else {
          // User originally had guide only, can't deselect without having explorer first
          toast.warning(I18n.t('must_keep_at_least_one_role', {
            role: I18n.t('account_type_selection_senior'),
            currentRole: I18n.t('account_type_selection_senior_buddy')
          }) || 'Bạn phải giữ ít nhất một vai trò. Vui lòng chọn Explorer trước khi tắt Guide.', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-warning-container toast-warning-container-after',
          });
          return;
        }
      } else if (currentType === SENIOR) {
        // If Explorer is selected, add Guide (both)
        // Check if user has youthCommunity from user props first, then state
        const previousYouthCommunity = this.props.user?.youthCommunity;
        let youthCommunityToUse = this.state.youthCommunity;
        
        // Extract the actual ID/value from user.youthCommunity
        // It could be: string (_id), string (value), or object {value, label, _id}
        let youthCommunityToFind = null;
        if (previousYouthCommunity) {
          if (typeof previousYouthCommunity === 'string') {
            youthCommunityToFind = previousYouthCommunity;
          } else if (typeof previousYouthCommunity === 'object') {
            // It's an object, try _id first, then value
            youthCommunityToFind = previousYouthCommunity._id || previousYouthCommunity.value;
          }
        }
        
        // Always check user props for youthCommunity first (even if state has it)
        // This ensures we use the latest value from Redux
        if (youthCommunityToFind && this.state.listBuddyYouthCommunity.length > 0) {
          // Try to find by _id first
          const foundById = this.state.listBuddyYouthCommunity.find(c => c._id === youthCommunityToFind);
          if (foundById) {
            youthCommunityToUse = foundById._id;
          } else {
            // Fallback: try to find by value
            const foundByValue = this.state.listBuddyYouthCommunity.find(c => c.value === youthCommunityToFind);
            if (foundByValue) {
              youthCommunityToUse = foundByValue._id;
            }
          }
        }
        
        // If we found a valid youthCommunity, update directly without modal
        if (youthCommunityToUse && youthCommunityToUse !== '') {
          // Update state first
          this.setState({ youthCommunity: youthCommunityToUse }, () => {
            // Call updateRole with the found youthCommunity directly
            this.updateRole(BOTH);
          });
          return; // Return here since we're calling updateRole in callback
        } else {
          // No youthCommunity found, show modal
          // But try to pre-select from user props one more time
          const existingYouthCommunity = this.props.user?.youthCommunity;
          let preSelectedId = '';
          if (existingYouthCommunity && this.state.listBuddyYouthCommunity.length > 0) {
            // Extract ID/value from existingYouthCommunity
            let existingIdToFind = null;
            if (typeof existingYouthCommunity === 'string') {
              existingIdToFind = existingYouthCommunity;
            } else if (typeof existingYouthCommunity === 'object') {
              existingIdToFind = existingYouthCommunity._id || existingYouthCommunity.value;
            }
            
            if (existingIdToFind) {
              const found = this.state.listBuddyYouthCommunity.find(c => c._id === existingIdToFind || c.value === existingIdToFind);
              if (found) {
                preSelectedId = found._id;
              } else {
                // If not found in list, use the raw value as fallback
                preSelectedId = existingIdToFind;
              }
            }
          }
          this.setState({ 
            showGuideModal: true,
            modalYouthCommunity: preSelectedId,
          });
          return; // Return here to prevent updateRole from being called
        }
      } else if (currentType === BOTH) {
        // If both selected, remove Guide (keep Explorer)
        newType = SENIOR;
      } else {
        // If nothing selected (initial state), check if user had youthCommunity before
        const previousYouthCommunity = this.props.user?.youthCommunity;
        let youthCommunityToUse = this.state.youthCommunity;
        
        // Extract the actual ID/value from user.youthCommunity
        // It could be: string (_id), string (value), or object {value, label, _id}
        let youthCommunityToFind = null;
        if (previousYouthCommunity) {
          if (typeof previousYouthCommunity === 'string') {
            youthCommunityToFind = previousYouthCommunity;
          } else if (typeof previousYouthCommunity === 'object') {
            // It's an object, try _id first, then value
            youthCommunityToFind = previousYouthCommunity._id || previousYouthCommunity.value;
          }
        }
        
        // Always check user props for youthCommunity first (even if state has it)
        // This ensures we use the latest value from Redux
        if (youthCommunityToFind && this.state.listBuddyYouthCommunity.length > 0) {
          // Try to find by _id first
          const foundById = this.state.listBuddyYouthCommunity.find(c => c._id === youthCommunityToFind);
          if (foundById) {
            youthCommunityToUse = foundById._id;
          } else {
            // Fallback: try to find by value
            const foundByValue = this.state.listBuddyYouthCommunity.find(c => c.value === youthCommunityToFind);
            if (foundByValue) {
              youthCommunityToUse = foundByValue._id;
            }
          }
        }
        
        // If we found a valid youthCommunity, update directly without modal
        if (youthCommunityToUse && youthCommunityToUse !== '') {
          // Update state first
          this.setState({ youthCommunity: youthCommunityToUse }, () => {
            // Call updateRole with the found youthCommunity directly
            this.updateRole(BUDDY);
          });
          return; // Return here since we're calling updateRole in callback
        } else {
          // No youthCommunity found, show modal
          // But try to pre-select from user props one more time
          const existingYouthCommunity = this.props.user?.youthCommunity;
          let preSelectedId = '';
          if (existingYouthCommunity && this.state.listBuddyYouthCommunity.length > 0) {
            // Extract ID/value from existingYouthCommunity
            let existingIdToFind = null;
            if (typeof existingYouthCommunity === 'string') {
              existingIdToFind = existingYouthCommunity;
            } else if (typeof existingYouthCommunity === 'object') {
              existingIdToFind = existingYouthCommunity._id || existingYouthCommunity.value;
            }
            
            if (existingIdToFind) {
              const found = this.state.listBuddyYouthCommunity.find(c => c._id === existingIdToFind || c.value === existingIdToFind);
              if (found) {
                preSelectedId = found._id;
              } else {
                // If not found in list, use the raw value as fallback
                preSelectedId = existingIdToFind;
              }
            }
          }
          this.setState({ 
            showGuideModal: true,
            modalYouthCommunity: preSelectedId,
          });
          return; // Return here to prevent updateRole from being called
        }
      }
    }
    
    // Ensure at least one role is always selected (double check)
    if (!newType || newType === '') {
      toast.error(I18n.t('must_select_at_least_one_role') || 'Bạn phải chọn ít nhất một vai trò', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-error-container toast-error-container-after',
      });
      return;
    }
    
    await this.updateRole(newType);
  };

  handleSelectCommunity = (data) => {
    this.setState({ youthCommunity: data });
  };

  handleModalSelectCommunity = (data) => {
    // Ensure we store the value correctly
    // data could be: string (_id), string (value), or empty string
    const valueToStore = data && data.trim ? data.trim() : data;
    this.setState({ modalYouthCommunity: valueToStore });
  };

  closeGuideModal = () => {
    this.setState({ 
      showGuideModal: false,
      modalYouthCommunity: '',
    });
  };

  handleBecomeGuide = async () => {
    const { modalYouthCommunity, listBuddyYouthCommunity } = this.state;
    const currentType = this.state.selectedType;
    
    // Try to get value from select element directly first (in case state hasn't updated)
    // This ensures we get the current selected value even if state update is pending
    let selectedValue = null;
    try {
      // Try to use ref first, then fall back to DOM query
      const selectElement = this.youthCommunitySelectRef.current || 
                           document.querySelector('.become-guide-modal select');
      if (selectElement && selectElement.value && selectElement.value !== '') {
        selectedValue = selectElement.value;
        // Update state immediately to keep it in sync
        if (selectedValue !== modalYouthCommunity) {
          this.setState({ modalYouthCommunity: selectedValue });
        }
      }
    } catch (e) {
      // If we can't access DOM, fall back to state
      console.warn('Could not access select element:', e);
    }
    
    // If we didn't get value from DOM, use state
    if (!selectedValue) {
      // Extract the actual value from modalYouthCommunity
      // It could be: string (_id), string (value), or empty string
      selectedValue = modalYouthCommunity;
      if (typeof modalYouthCommunity === 'object' && modalYouthCommunity !== null) {
        selectedValue = modalYouthCommunity._id || modalYouthCommunity.value || '';
      } else if (typeof modalYouthCommunity === 'string') {
        selectedValue = modalYouthCommunity.trim();
      }
    }
    
    // Validate that a youth community is selected
    if (!selectedValue || selectedValue === '' || selectedValue === 'null' || selectedValue === 'undefined') {
      toast.error(I18n.t('please_select_youth_community') || 'Vui lòng chọn cộng đồng thanh niên', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-error-container toast-error-container-after',
      });
      return;
    }
    
    // Update state with selected youth community
    this.setState({ 
      youthCommunity: selectedValue,
      modalYouthCommunity: selectedValue, // Ensure state is also updated
      showGuideModal: false,
    });
    
    // Determine new type: if currently explorer, become both; otherwise become guide
    const newType = currentType === SENIOR ? BOTH : BUDDY;
    
    // Use _id of youthCommunity for API
    let youthCommunityId = null;
    if (selectedValue && listBuddyYouthCommunity.length > 0) {
      // Try to find by _id first
      const foundById = listBuddyYouthCommunity.find(item => 
        item._id === selectedValue || 
        (item._id && item._id.toString() === selectedValue.toString())
      );
      if (foundById) {
        youthCommunityId = foundById._id;
      } else {
        // Fallback: try to find by value (backward compatibility)
        const foundByValue = listBuddyYouthCommunity.find(item => 
          item.value === selectedValue || 
          (item.value && item.value.toString() === selectedValue.toString())
        );
        if (foundByValue) {
          youthCommunityId = foundByValue._id;
        } else {
          // Try to find by label (in case value is the label text)
          const foundByLabel = listBuddyYouthCommunity.find(item => 
            item.label === selectedValue || 
            (item.label && item.label.toString() === selectedValue.toString())
          );
          if (foundByLabel) {
            youthCommunityId = foundByLabel._id;
          } else {
            // If not found, use the value directly (might be an ObjectId string)
            youthCommunityId = selectedValue;
          }
        }
      }
    } else if (selectedValue) {
      // If list is empty but we have a value, use it directly
      youthCommunityId = selectedValue;
    }
    
    // Call updateRole with the youth community _id
    await this.updateRoleWithYouthCommunity(newType, youthCommunityId);
  };

  updateRoleWithYouthCommunity = async (newType, youthCommunityId) => {
    if (this.state.isLoading) return;
    
    this.setState({ isLoading: true });
    
    try {
      const { updateMvpUserType, fetchUserMvp, user } = this.props;
      
      await updateMvpUserType(newType, youthCommunityId);
      
      // Ensure user data is refreshed and localStorage is updated
      // updateMvpUserType already calls fetchUserMvp, but we call it again to ensure
      // all components get the latest data
      await fetchUserMvp((updatedUser) => {
        if (updatedUser) {
          // User data has been updated in Redux and localStorage
          // This ensures all components using user data get the latest info
        }
      });
      
      this.setState({ selectedType: newType });
      
      toast.success(I18n.t('role_updated_successfully') || 'Cập nhật vai trò thành công!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-success-container toast-success-container-after',
      });
    } catch (err) {
      toast.error(err.message || I18n.t('something_wrong'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-error-container toast-error-container-after',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateRole = async (newType) => {
    if (this.state.isLoading) return;
    
    this.setState({ isLoading: true });
    
    try {
      const { updateMvpUserType, fetchUserMvp, user } = this.props;
      const { youthCommunity, listBuddyYouthCommunity } = this.state;
      
      // If switching to guide or both, need youthCommunity
      let youthCommunityId = null;
      if (newType === BUDDY || newType === BOTH) {
        // If user was explorer before, youthCommunity is required
        if (user?.mvpUserType === SENIOR || !user?.mvpUserType) {
          if (!youthCommunity || youthCommunity === '') {
            toast.error(I18n.t('please_select_youth_community') || 'Vui lòng chọn cộng đồng thanh niên', {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: 'colored',
              className: 'toast-error-container toast-error-container-after',
            });
            this.setState({ isLoading: false });
            return;
          }
        }
        
        // Use _id of youthCommunity
        if (youthCommunity && listBuddyYouthCommunity.length > 0) {
          // Try to find by _id first
          const foundById = listBuddyYouthCommunity.find(item => item._id === youthCommunity);
          if (foundById) {
            youthCommunityId = foundById._id;
          } else if (user?.youthCommunity) {
            // If user already has youthCommunity, try to find it in the list
            // Try by _id first
            const existingById = listBuddyYouthCommunity.find(item => item._id === user.youthCommunity);
            if (existingById) {
              youthCommunityId = existingById._id;
            } else {
              // Fallback: try by value (backward compatibility)
              const existingByValue = listBuddyYouthCommunity.find(item => item.value === user.youthCommunity);
              if (existingByValue) {
                youthCommunityId = existingByValue._id;
              }
            }
          }
        }
      }
      
      await updateMvpUserType(newType || user?.mvpUserType, youthCommunityId);
      
      // Ensure user data is refreshed and localStorage is updated
      // updateMvpUserType already calls fetchUserMvp, but we call it again to ensure
      // all components get the latest data
      await fetchUserMvp((updatedUser) => {
        if (updatedUser) {
          // User data has been updated in Redux and localStorage
          // This ensures all components using user data get the latest info
        }
      });
      
      this.setState({ selectedType: newType || user?.mvpUserType });
      
      toast.success(I18n.t('role_updated_successfully') || 'Cập nhật vai trò thành công!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-success-container toast-success-container-after',
      });
    } catch (err) {
      toast.error(err.message || I18n.t('something_wrong'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-error-container toast-error-container-after',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { user } = this.props;
    const { selectedType, listBuddyYouthCommunity, youthCommunity, isLoading } = this.state;
    const isSenior = selectedType === SENIOR || selectedType === BOTH;
    const isBuddy = selectedType === BUDDY || selectedType === BOTH;

    return (
      <div className="px-0 user-role-selection" style={{ padding: '0' }}>
        <h3 className="title mt-3 mb-4" style={{ color: '#FFFFFF' }}>
          {I18n.t('role') || 'Vai trò'}
        </h3>
        
        <div style={{ 
          color: '#FFFFFF', 
          borderRadius: '12px', 
          padding: '32px',
          marginBottom: '24px'
        }}>
          
          {/* Two boxes side by side */}
          <div style={{ 
            display: 'flex', 
            gap: '16px', 
            flexWrap: 'wrap',
            marginBottom: '24px'
          }}>
            {/* Explorer Box */}
            <div
              className={`card-sign-up senior cursor-pointer ${isSenior ? 'checked' : ''}`}
              onClick={() => this.handleChooseType(SENIOR)}
              style={{
                flex: '1',
                minWidth: '280px',
                marginBottom: 0,
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? 'not-allowed' : 'pointer',
                backgroundColor: isSenior ? '#699CF4' : '#3E4856',
                padding: '18px 20px',
                height: '154px',
                borderRadius: '12px',
                border: isSenior ? 'none' : '1px solid #374151',
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h5 className="mb-0" style={{ color: '#FFFFFF' }}>{I18n.t('account_type_selection_senior')}</h5>
                <div
                  style={{
                    width: '48px',
                    height: '24px',
                    borderRadius: '12px',
                    backgroundColor: isSenior ? '#E87623' : '#EEEFF2',
                    position: 'relative',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    transition: 'background-color 0.3s ease',
                    flexShrink: 0,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isLoading) {
                      this.handleChooseType(SENIOR);
                    }
                  }}
                >
                  <div
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#FFFFFF',
                      position: 'absolute',
                      top: '2px',
                      left: isSenior ? '26px' : '2px',
                      transition: 'left 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    }}
                  />
                </div>
              </div>
              <span style={{ color: '#FFFFFF' }}>
                {I18n.t('account_type_selection_senior_des')}
              </span>
            </div>

            {/* Guide Box */}
            <div
              className={`card-sign-up buddy cursor-pointer ${isBuddy ? 'checked' : ''}`}
              onClick={() => this.handleChooseType(BUDDY)}
              style={{
                flex: '1',
                minWidth: '280px',
                marginBottom: 0,
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? 'not-allowed' : 'pointer',
                backgroundColor: isBuddy ? '#699CF4' : '#3E4856',
                padding: '18px 20px',
                height: '154px',
                borderRadius: '12px',
                border: isBuddy ? 'none' : '1px solid #374151',
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h5 className="mb-0" style={{ color: '#FFFFFF' }}>{I18n.t('account_type_selection_senior_buddy')}</h5>
                <div
                  style={{
                    width: '48px',
                    height: '24px',
                    borderRadius: '12px',
                    backgroundColor: isBuddy ? '#E87623' : '#EEEFF2',
                    position: 'relative',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    transition: 'background-color 0.3s ease',
                    flexShrink: 0,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isLoading) {
                      this.handleChooseType(BUDDY);
                    }
                  }}
                >
                  <div
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#FFFFFF',
                      position: 'absolute',
                      top: '2px',
                      left: isBuddy ? '26px' : '2px',
                      transition: 'left 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    }}
                  />
                </div>
              </div>
              <span style={{ color: '#FFFFFF' }}>
                {I18n.t('account_type_selection_senior_buddy_des')}
              </span>
            </div>
          </div>

          {/* Youth Community Selection - Removed: Only used in modal when activating Guide role */}
        </div>

        {/* Become Guide Modal */}
        <style>{`
          .become-guide-modal .modal-content {
            background-color: transparent;
            border: none;
            box-shadow: none;
          }
        `}</style>
        <Modal
          className="become-guide-modal"
          visible={this.state.showGuideModal}
          dialogClassName="modal-dialog-centered"
          onClickBackdrop={this.closeGuideModal}
        >
          <div className="modal-body" style={{
            padding: '40px',
            backgroundColor: '#1F2937',
            borderRadius: '12px',
            maxWidth: '500px',
            width: '100%'
          }}>
            {/* Title */}
            <h4 style={{ 
              color: '#FFFFFF', 
              fontSize: '24px', 
              fontWeight: '600', 
              marginBottom: '16px',
              lineHeight: '1.4',
              textAlign: 'center'
            }}>
              {I18n.t('ready_to_become_guide_title')}
            </h4>

            {/* Description */}
            <p style={{ 
              color: '#fff', 
              fontSize: '16px', 
              lineHeight: '1.5', 
              marginBottom: '24px',
              textAlign: 'center'
            }}>
              {I18n.t('ready_to_become_guide_description')}
            </p>

            {/* Benefits List */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: '12px',
                color: '#FFFFFF'
              }}>
                <span style={{ fontSize: '20px', marginRight: '12px' }}>💰</span>
                <span style={{ fontSize: '16px', lineHeight: '1.5' }}>
                  {I18n.t('ready_to_become_guide_benefit_1')}
                </span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: '12px',
                color: '#FFFFFF'
              }}>
                <span style={{ fontSize: '20px', marginRight: '12px' }}>🤝</span>
                <span style={{ fontSize: '16px', lineHeight: '1.5' }}>
                  {I18n.t('ready_to_become_guide_benefit_2')}
                </span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: '12px',
                color: '#FFFFFF'
              }}>
                <span style={{ fontSize: '20px', marginRight: '12px' }}>🗓️</span>
                <span style={{ fontSize: '16px', lineHeight: '1.5' }}>
                  {I18n.t('ready_to_become_guide_benefit_3')}
                </span>
              </div>
            </div>

            {/* Youth Community Label */}
            <label style={{ 
              display: 'block', 
              color: '#FFFFFF', 
              fontSize: '16px', 
              marginBottom: '12px',
              fontWeight: '500'
            }}>
              {I18n.t('youth_community_question')} <small className="error" style={{ color: '#FF445D', marginLeft: '4px' }}>*</small>
            </label>

            {/* Youth Community Select */}
            <select
              ref={this.youthCommunitySelectRef}
              value={(() => {
                // Use modalYouthCommunity from state first
                const modalValue = this.state.modalYouthCommunity;
                if (modalValue) {
                  // If modalYouthCommunity is object, extract _id or value
                  if (typeof modalValue === 'object' && modalValue !== null) {
                    const extracted = modalValue._id || modalValue.value;
                    return extracted || '';
                  }
                  // If it's a string, return it directly
                  if (typeof modalValue === 'string') {
                    return modalValue;
                  }
                }
                // If not set, try to find from user.youthCommunity
                if (this.props.user?.youthCommunity && this.state.listBuddyYouthCommunity.length > 0) {
                  // Extract ID/value from user.youthCommunity
                  let youthCommunityToFind = null;
                  if (typeof this.props.user.youthCommunity === 'string') {
                    youthCommunityToFind = this.props.user.youthCommunity;
                  } else if (typeof this.props.user.youthCommunity === 'object') {
                    youthCommunityToFind = this.props.user.youthCommunity._id || this.props.user.youthCommunity.value;
                  }
                  
                  if (youthCommunityToFind) {
                    const foundById = this.state.listBuddyYouthCommunity.find(c => 
                      c._id === youthCommunityToFind || 
                      (c._id && c._id.toString() === youthCommunityToFind.toString())
                    );
                    if (foundById) {
                      return foundById._id;
                    }
                    const foundByValue = this.state.listBuddyYouthCommunity.find(c => 
                      c.value === youthCommunityToFind || 
                      (c.value && c.value.toString() === youthCommunityToFind.toString())
                    );
                    if (foundByValue) {
                      return foundByValue._id;
                    }
                  }
                }
                return '';
              })()}
              onChange={(e) => {
                const selectedValue = e.target.value;
                // Only update if a valid value is selected (not the placeholder)
                if (selectedValue && selectedValue !== '') {
                  this.handleModalSelectCommunity(selectedValue);
                } else {
                  // Clear the selection
                  this.handleModalSelectCommunity('');
                }
              }}
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '12px 16px',
                fontSize: '16px',
                color: '#FFFFFF',
                backgroundColor: '#282F39',
                border: '1px solid #374151',
                borderRadius: '8px',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                marginBottom: '32px'
              }}
            >
              <option value="">{I18n.t('select_youth_community')}</option>
              {this.state.listBuddyYouthCommunity.map((item, index) => {
                if (index === 0 && item.value === '') return null; // Skip placeholder
                // Ensure we have a valid value for the option
                // Prefer _id, fall back to value, then use a temp value
                const optionValue = item._id || item.value;
                if (!optionValue || optionValue === '') return null; // Skip if no valid value
                return (
                  <option key={item._id || item.value || index} value={optionValue}>
                    {item.label || item.value || `Community ${index}`}
                  </option>
                );
              })}
            </select>

            {/* Buttons - always on one row; VI: 30% / 70%, EN: 50% / 50% */}
            {(() => {
              const isVi = I18n.language === 'vi';
              return (
            <div style={{
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              alignItems: 'stretch',
              flexWrap: 'nowrap'
            }}>
              {/* Maybe Later Button */}
              <button
                type="button"
                onClick={this.closeGuideModal}
                style={{
                  backgroundColor: 'transparent',
                  color: '#1AEEC2',
                  border: '1px solid #1AEEC2',
                  borderRadius: '16px',
                  padding: '12px 20px',
                  fontSize: '15px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  minWidth: '0',
                  flex: isVi ? '0 0 calc(30% - 10px)' : '1 1 0',
                  whiteSpace: 'normal',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(55, 65, 81, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                {I18n.t('maybe_later')}
              </button>

              {/* Become a Guide Button */}
              <button
                type="button"
                onClick={this.handleBecomeGuide}
                disabled={isLoading}
                style={{
                  backgroundColor: '#1AEEC2',
                  color: '#000',
                  border: 'none',
                  borderRadius: '16px',
                  padding: '12px 20px',
                  fontSize: '15px',
                  fontWeight: '500',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  minWidth: '0',
                  flex: isVi ? '0 0 calc(70% - 10px)' : '1 1 0',
                  opacity: isLoading ? 0.6 : 1,
                  whiteSpace: 'normal',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.backgroundColor = '#16EAB1';
                  }
                }}
                onMouseOut={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.backgroundColor = '#1AEEC2';
                  }
                }}
              >
                {isLoading ? I18n.t('processing') : I18n.t('become_a_guide')}
              </button>
            </div>
              );
            })()}
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
  updating: user?.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateMvpUserType: (mvpUserType, youthCommunity) => dispatch(updateMvpUserType(mvpUserType, youthCommunity)),
  getBuddyYouthCommunity: (options) => dispatch(getBuddyYouthCommunity(options)),
  fetchUserMvp: () => dispatch(fetchUserMvp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleSelection);

